module.exports = __webpack_public_path__ + "img/trackd-icon-white.315a5b4c.svg";